import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          常见问题
        </h2>
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 pr-4">{item.q}</h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === idx ? 'max-h-[300px] pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'}`}>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}